import { TBreakpointLabels } from "../utils/constants/hooks/breakpoints";

type TBreakPointsValue<T> = { [breakpoint in TBreakpointLabels]?: T };

export function getValueOnBreakpoint<T = any>(
  value: TBreakPointsValue<T>,
  breakpoint: TBreakpointLabels
) {
  // if (!value) return {};

  let data = { ...value.all };

  // TODO SOLVE THE ISSUE BETWEEN DESKTOP AND TABLET FOUND ON XGRID

  if (breakpoint === "desktop") {
    data = { ...data, ...value.mobile, ...value.tablet, ...value.desktop };
  } else if (breakpoint === "tablet") {
    data = { ...data, ...value.mobile, ...value.tablet };
  } else if (breakpoint === "mobile") {
    data = { ...data, ...value.mobile };
  } else {
    data = { ...value.mobile, ...value.tablet, ...value.desktop, ...data };
  }

  return data as T;
}
